
import Divider from 'vux/src/components/divider/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XTable from 'vux/src/components/x-table/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Selector from 'vux/src/components/selector/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'

import common from '@/tools/common'
import vSelect from './vselect'
export default {
directives: {
TransferDom
},
components: {
vSelect,
Divider,
XInput,
Group,
Cell,
Search,
XButton,
Flexbox,
Card,
FlexboxItem,
XTable,
Popup,
Selector,
Alert,
Datetime,
XDialog
},
methods: {
showData: function () {
let allcontent = document.getElementById('allcontent')
let alltext = allcontent.innerText
if (alltext.indexOf(this.queryMessage) <= 0) {
window.alert('本页未找到搜索内容')
return
}
this.currentItem.R_Content = this.ReplaceStr(this.currentItem.R_Content)
let dom = document.getElementById('rulesinfor')


if (this.replacetext !== '' && this.replaceOldText !== '') {
let old = new RegExp(this.replacetext, 'g')
this.currentItem.R_Content = this.currentItem.R_Content.replace(old, this.replaceOldText)
this.currentItem.R_Title = this.currentItem.R_Title.replace(old, this.replaceOldText)
dom.innerHTML = dom.innerHTML.replace(old, this.replaceOldText)
}
let reg = new RegExp(this.queryMessage, 'g')
this.replacetext = '<span style="font-size:17px !important;color:red !important; background: yellow !important">' + this.queryMessage + '</span>'
this.replaceOldText = this.queryMessage
this.currentItem.R_Content = this.currentItem.R_Content.replace(reg, '<span style="font-size:17px !important;color:red !important; background: yellow !important">' + this.queryMessage + '</span>')

this.currentItem.R_Title = this.currentItem.R_Title.replace(reg, '<span style="font-size:17px !important;color:red !important; background: yellow !important">' + this.queryMessage + '</span>')
let oldhtml = dom.innerHTML
let newruleinfo = oldhtml.replace(reg, '<span style="font-size:17px !important;color:red !important; background: yellow !important">' + this.queryMessage + '</span>')
dom.innerHTML = newruleinfo
console.log(newruleinfo)

},
ReplaceStr: function (str) {
if (str) {
let old = new RegExp('font-size:14.0pt;font-family:宋体;', 'g')
let newstr = str.replace(old, '')

return newstr
}
return str
}
},
data () {
return {
queryResult: {Data: [], TotalPage: 0},
queryMessage: '',
replacetext: '',
replaceOldText: '',
ruleinfotext: '',
ruleinfoOldeText: '',
currentItem: null
}
},
beforeCreate: function () {
this.querydata = common.getPower()
},
async activated () {


const queryPromise = await this.$http.get('/API/RuleSearch/GetDetailsSql', {params: this.$route.query})
this.currentItem = queryPromise.data

}
}



// WEBPACK FOOTER //
// ./src/components/RulesSearchDetails.vue